import React from "react";
import norachat from './assets/norachat.png';
import sender from './assets/sender.png';

export default function MessageBubble({ msg }) {
  return (
    <div className={`message ${msg.sender}`}>
      <div className={`chat-img-user ${msg.sender}-avatar`}>
        {msg.sender === "bot" ? (
          <img src={norachat} alt="bot" />
        ) : (
          <img src={sender} alt="user" />
        )}
      </div>
      <div className="bubble">
        {msg.isTemp ? (
          <div className="typing-indicator" aria-label="Typing...">
            <span></span>
            <span></span>
            <span></span>
          </div>
        ) : (
          msg.text
        )}
      </div>
    </div>
  );
}